import React from 'react';

const ChangePasswordModal = ({ 
  isOpen, 
  onClose, 
  passwordForm,
  setPasswordForm,
  passwordError,
  passwordSuccess,
  isChangingPassword,
  onSubmit
}) => {
  if (!isOpen) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        padding: '20px'
      }}
      onClick={() => {
        onClose();
        setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      }}
    >
      <div 
        style={{
          background: 'white',
          borderRadius: '16px',
          maxWidth: '500px',
          width: '100%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #e2e8f0'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ margin: 0, color: 'var(--deep-blue)', fontSize: '1.5rem', fontWeight: '700' }}>
              🔒 Change Password
            </h2>
            <button
              onClick={() => {
                onClose();
                setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
              }}
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: '8px',
                fontSize: '1.5rem',
                color: '#64748b'
              }}
            >
              ×
            </button>
          </div>
        </div>
        <form onSubmit={onSubmit} style={{ padding: '24px' }}>
          {passwordSuccess && (
            <div style={{
              padding: '12px',
              marginBottom: '20px',
              background: '#d4edda',
              color: '#155724',
              borderRadius: '8px',
              fontSize: '0.875rem'
            }}>
              {passwordSuccess}
            </div>
          )}
          {passwordError && (
            <div style={{
              padding: '12px',
              marginBottom: '20px',
              background: '#f8d7da',
              color: '#721c24',
              borderRadius: '8px',
              fontSize: '0.875rem'
            }}>
              {passwordError}
            </div>
          )}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '0.875rem' }}>
              Current Password
            </label>
            <input
              type="password"
              value={passwordForm.currentPassword}
              onChange={(e) => setPasswordForm({ ...passwordForm, currentPassword: e.target.value })}
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                fontSize: '1rem'
              }}
              placeholder="Enter current password"
            />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '0.875rem' }}>
              New Password
            </label>
            <input
              type="password"
              value={passwordForm.newPassword}
              onChange={(e) => setPasswordForm({ ...passwordForm, newPassword: e.target.value })}
              required
              minLength={8}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                fontSize: '1rem'
              }}
              placeholder="Enter new password (min 8 characters)"
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '0.875rem' }}>
              Confirm New Password
            </label>
            <input
              type="password"
              value={passwordForm.confirmPassword}
              onChange={(e) => setPasswordForm({ ...passwordForm, confirmPassword: e.target.value })}
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                fontSize: '1rem'
              }}
              placeholder="Confirm new password"
            />
          </div>
          <button
            type="submit"
            disabled={isChangingPassword}
            style={{
              width: '100%',
              padding: '14px',
              background: isChangingPassword 
                ? '#cbd5e0'
                : 'linear-gradient(135deg, var(--deep-blue), var(--accent-teal))',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: isChangingPassword ? 'not-allowed' : 'pointer',
              opacity: isChangingPassword ? 0.6 : 1
            }}
          >
            {isChangingPassword ? 'Changing Password...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
